import * as Campaigns from '../campaigns';
import * as Groups    from '../groups';
import * as Templates from '../campaign_templates';
import ComposePage    from './compose_page';
import React          from 'react';
import WaitFor        from '../components/wait_for';


export default function AddPage({ businessID, query }) {
  const statuses = [
    Campaigns.useCampaignsStatuses(businessID),
    Templates.useTemplatesStatuses(businessID),
    Groups.useGroupsStatuses(businessID)
  ];

  const queryCampaign = Campaigns.useCampaign(query.campaign);
  const queryTemplate = Templates.useTemplate(query.template);
  const groups        = Groups.useGroups(businessID);
  const initialRecord = getInitialRecord({ queryCampaign, queryTemplate, groups });
  const pageTitle     = 'New Campaign';

  return (
    <WaitFor statuses={statuses}>
      <ComposePage {...{ businessID, initialRecord, pageTitle }}/>
    </WaitFor>
  );
}


const blankRecord = {
  subject: '',
  body:    ''
};


function getInitialRecord({ queryCampaign, queryTemplate, groups }) {
  const record = queryCampaign || queryTemplate || blankRecord;

  const { subject, body } = record;
  const group             = getGroup(groups, record.group);

  return {
    subject,
    body,
    status:     'draft',
    group:      group?.name,
    recipients: group?.customers || []
  };
}


function getGroup(groups, groupName) {
  return groupName && groups.find(item => item.name === groupName);
}
